{
  "name": "snappy-open",
  "_note": "개봉/뒤집기를 빠르고 탄력 있게. 상단이 더 빨리 날아가고 카드는 살짝 튕기며 자리잡는다. 뒤집기 오버슈트 큼.",
  "open": {
    "topFlySpeed": 20,
    "topSpin": 6.5,
    "bodySinkSpeed": 9,
    "cardDelay": 0.08,
    "cardStagger": 0.012,
    "cardRiseSpeed": 14,
    "cardRiseDamping": 0.65,
    "spreadPos": 0.1,
    "spreadAngle": 0.03
  },
  "flip": {
    "duration": 0.24,
    "overshoot": 0.14,
    "tapInfluence": 0.18
  }
}
